import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import router from './router'
import 'babel-polyfill'
import axios from 'axios';
import './assets/css/initialize.css'
import './assets/css/index.css'
import './assets/css/animate.css'
import Alertify from 'alertify.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import AppUtils from './utils'
import VeeValidate, {Validator} from 'vee-validate'
import store from './store/index'
// import Map from './assets/js/map'
import * as filters from './assets/js/filter'
import VueAMap from 'pass-a-map-vue2';
// import  './assets/js/sockjs.min'
// import  './assets/js/stomp'
import envConfig  from './common/env';
import VueClipboard from 'vue-clipboard2'
import {mavonEditor} from "mavon-editor";
// 图片放大缩小插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})
import "mavon-editor/dist/css/index.css";
Vue.use(VueClipboard)

// window._AMapSecurityConfig = {
//   securityJsCode:'19b5730ae50dc7448519e09f36d3d181',//高德地图密钥
// }
VueAMap.initAMapApiLoader({
  key: '6i7waloeWFMCKSVrPR4mkdo',
  plugin: ['AMap.AutoComplete', 'AMap.PlaceSearch','AMap.DistrictSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor','AMap.Driving' ,'AMap.LngLat','AMap.CircleEditor','AMap.Geocoder','Scale','AMap.Heatmap','AMap.MouseTool'],
  // 默认高德 sdk 版本为 1.4.4
  v: '2.0'
});
const amapKeys = Object.keys(localStorage).filter(key => key.match(/^_AMap_/))
amapKeys.forEach(key => {
  localStorage.removeItem(key)
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});
Alertify.logPosition('bottom right')
Alertify.maxLogItems(6)
Alertify.okBtn('确认')
Alertify.cancelBtn('取消')
Vue.use(ElementUI);
let globalLoading = null;
function startLoading() {
  globalLoading = ElementUI.Loading.service({ 
    lock: true,
    text: '加载中...',
    background: 'rgba(255, 255, 255, 0.5)'
  })
}
function stopLoadiing() {
  globalLoading.close()
}
axios.interceptors.request.use(
  function (config) {
    var arr=config.url.split('/')
    // 这里的config包含每次请求的内容
    // store.state.isLoading = true;
    if(config.url.indexOf('/robot/api/qiWeRobot/loginCheck') == -1) {
      startLoading();
    }
    if(config.url.indexOf('/robot/api/robot/loginCheck') != -1 || config.url.indexOf('/robot/api/qiWeRobot/loginCheck') != -1) {
      // store.state.isLoading = false;
      stopLoadiing();
    }
    // if (store.state.token&&arr.indexOf('adPush')<0&&arr.indexOf('rule')<0&&arr.indexOf('sms')<0) {
    if (store.state.token && arr.indexOf('rule') < 0 && arr.indexOf('sms') < 0) {
      config.headers['RM-Token'] = store.state.token;
      config.headers['RM-Device'] = 101;
    }
    // 品牌管理测试接口修改
    if(arr.indexOf("brand")>0){
      config.url = envConfig.geUrl + config.url
    }
    return config;
  },
  function (err) {
    stopLoadiing();
    return Promise.reject(err);
  },
);
// axios 统一处理网络错误
axios.interceptors.response.use(
  response => {
    // store.state.isLoading = false;
    stopLoadiing();
    if (response.status == '200') {
      return response;
    } else if (response.status == '505') {
      Alertify.alert(response.data.message)
      return Promise.reject(response);
    } else if (response.status == '300') {
      Alertify.alert(response.data.message)
      return Promise.reject(response);
    } else if ([403, 404].indexOf(response.status) > -1) {
      this.$router.replace('/404')
    } else {
      Alertify.alert(response.data.message)
      return Promise.reject(response);
    }
  },
  error => {
    // store.state.isLoading = false;
    stopLoadiing();
    Alertify.alert('网络请求失败');
    return Promise.reject(error);
  },
);
axios.defaults.baseURL = envConfig.baseUrl;
axios.defaults.withCredentials=true;
// axios.defaults.withCredentials=true;

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VueAMap);
Vue.use(VeeValidate, {
  errorBagName: 'vaerrors',
  inject: true,
  enableAutoClasses: true,
  events: 'change',
  classNames: {
    invalid: 'invalid', // model is invalid
  },
  fieldsBagName: 'fieldBags',
});
Vue.component('nt-pagination', require('./components/pagination'));
Vue.component('nt-date-selector', require('./components/date-selector'));
Vue.component('nt-no-data', require('./components/no-data'));
Vue.component('nt-pulse-loader', require('./components/pulse-loader'));
Vue.component('nt-preview-image', require('./components/preview-image'));
Vue.component('nt-send', require('./components/sendMask'));
Vue.component('mavonEditor',mavonEditor);
Vue.component('ExportButton', require('./components/excelCase/exportButton.vue'));
Vue.component('ExportMessage', require('./components/excelCase/exportMessage.vue'));
Vue.prototype.AppUtils = AppUtils;
// Vue.prototype.Map = Map;
// Vue.prototype.VueAMap = VueAMap;
Vue.prototype.$axios = axios;
Vue.prototype.$eventBus = new Vue();
Vue.directive('preventReClick', {
  inserted (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
      el.disabled = true
      setTimeout(() => {
        el.disabled = false
      }, binding.value || 2000)
    }
    })
  }
})

Vue.mixin({
  data() {
    return {
      CODE_SERVER:envConfig.baseUrl,
      FENCE_SERVER:envConfig.fenceUrl,
      SHARE_SERVER:envConfig.shareUrl,
    }
  },
})
new Vue({
  store,
  router,
  components: {App},
  template: '<App/>',
  created() {
    AppUtils.authInit(this)
      .then(() => this.$mount('#app'));
  },
})


// WEBPACK FOOTER //
// ./src/main.js